<script setup lang="ts">
import Header from "@/components/Header.vue";
import { useFilesStore } from "@/stores/files";
import { computed } from "vue";

const fileStore = useFilesStore();
const fileCount = computed(() => fileStore.fullFiles.length);
</script>

<template>
    <div class="session-finalized">
        <Header class="header" />
        <div class="session-finalized__box">
            <div class="status-box">
                <div class="status-box__header">
                    <div class="text-secondary">
                        <h1>success</h1>
                        <h2>session finalized</h2>
                    </div>
                    <div class="icon">
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M18.88 25.92L14.4 30.4L28.8 44.8L60.8 12.8L56.32 8.32L28.8 35.84L18.88 25.92ZM57.6 32C57.6 46.08 46.08 57.6 32 57.6C17.92 57.6 6.4 46.08 6.4 32C6.4 17.92 17.92 6.4 32 6.4C34.56 6.4 36.8 6.72 39.04 7.36L44.16 2.24C40.32 0.96 36.16 0 32 0C14.4 0 0 14.4 0 32C0 49.6 14.4 64 32 64C49.6 64 64 49.6 64 32H57.6Z"
                                fill="#4AA54F"
                            />
                        </svg>
                    </div>
                </div>
                <div class="text-main status-box__body">
                    <p>Current session has been finalised.</p>
                    <p>You can now close the window.</p>
                </div>
            </div>
            <div class="status-box">
                <div class="status-box__header">
                    <div class="text-secondary">
                        <h2>all {{ fileCount }} files</h2>
                        <h2>will be uploaded</h2>
                        <h2>and analyzed</h2>
                    </div>
                </div>
                <div class="text-main status-box__body">
                    <p>Come back to the Uploader in Filemaker</p>
                    <p>in couple hours to view your media.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.header {
    position: absolute;
}

.session-finalized {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    user-select: none;
    gap: 15px;

    &__box {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 50px;
    }

    .status-box {
        display: flex;
        flex-direction: column;
        width: 300px;

        &__header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            gap: 30px;
            border-bottom: 1px solid #767676;

            padding: 15px 0;
            h1 {
                margin: 0;
                font-size: 64px;
                color: #4aa54f;
                line-height: 0.8;
                font-weight: 400;
            }
            h2 {
                margin: 0;
                font-size: 26px;
                text-transform: uppercase;
                color: #4aa54f;
                font-weight: 400;
                line-height: 1;
            }
            .icon {
                width: 64px;
                height: 64px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        &__body {
            font-size: 16px;
        }
    }
}
</style>
